module.exports = __webpack_public_path__ + "static/media/pikachu.15cb1e1a.png";